//JS for all date and time pickers
//On Select of Date picker

//global var to populate the min date on leaving field
var minDateforLeave;
var activeDatePickerLeaveClass = '.datepickerLeave';

function datePickerEntry(selectedDate) {
    //click time entry
    $('.timeEntry').focus();
    $('.priorityTimeEntry').focus();

    //populate leaving date 7 days in advance of selected
    var mdy = selectedDate.split('/');

    var tommorrowsDate = new Date(mdy[2], mdy[1] - 1, mdy[0]);
    tommorrowsDate.setDate(tommorrowsDate.getDate() + 1);

    minDateforLeave = tommorrowsDate;

    $(activeDatePickerLeaveClass).datepicker('option', 'minDate', selectedDate);
    $(activeDatePickerLeaveClass).datepicker('setDate', tommorrowsDate);

    //populate hidden fields for chauntry
    $('.start_date').val(selectedDate.replace('/', '').replace('/', ''));
    $('.end_date').val(formatDate(tommorrowsDate).toString().replace(',', '').replace(',', ''));
}

//On Select of Date picker
function datePickerLeave(selectedDate) {
    //populate hidden fields for chauntry
    var mdy = selectedDate.split('/');
    var seldate = new Date(mdy[2], mdy[1] - 1, mdy[0]);
    seldate.setFullYear(seldate.getFullYear());

    //populate hidden fields for chauntry
    //new
    $('.end_date').val(selectedDate.replace('/', '').replace('/', ''));
}

function timePicker(selectedTime, hiddenfield) {
    var formatTime = selectedTime.dateFormat('Hi');
    //populate hidden fields for chauntry
    $(hiddenfield).val(formatTime);
}

//format Date
function formatDate(date) {
    var lD = date.getDate();
    if (lD <= 9)
        lD = '0' + lD;
    var lM = date.getMonth();
    lM += 1;  // JavaScript months are 0-11
    if (lM <= 9)
        lM = '0' + lM;
    var lY = date.getFullYear();

    return [lD, lM, lY];
}


$(document).ready(function () {

    //Populating the inital value in dropdown boxes
    var todaysDate = new Date();
    todaysDate.setDate(todaysDate.getDate() + 1);
    var formatEntryDate = formatDate(todaysDate);

    var leavingDate = new Date();
    leavingDate.setDate(leavingDate.getDate() + 7);
    var formatLeavingDate = formatDate(leavingDate);

    //populate ACTUAL fields
    $('.dateEntry').val(formatEntryDate[0] + '/' + formatEntryDate[1] + '/' + formatEntryDate[2]);
    $('.timeEntry').val('08:00');
    $('.priorityTimeEntry').val('08:00');
    $('.dateLeave').val(formatLeavingDate[0] + '/' + formatLeavingDate[1] + '/' + formatLeavingDate[2]);
    $('.timeLeave').val('20:00');

    //populate hidden fields initally 
    $('.start_date').val(formatEntryDate[0].toString() + formatEntryDate[1].toString() + formatEntryDate[2].toString());
    $('.end_date').val(formatLeavingDate[0].toString() + formatLeavingDate[1].toString() + formatLeavingDate[2].toString());
    $('.start_time').val('0800');
    $('.leave_time').val('2000');
    $('.end_time').val('2000');

    //Exec Lounge populate hidden fields initally 
    $('.adult_quantity').val('1');
    $('.child_quantity').val('0');

    $('.adultsSelected').on('click', function () {
        $('.adult_quantity').val($(this).val());
    });

    $('.childrenSelected').on('click', function () {
        $('.child_quantity').val($(this).val());
    });

    setupDatePickers();

    $('.timeEntry').datetimepicker({
        datepicker: false,
        format: 'H:i',
        defaultTime: '08:00',
        formatTime: 'H:i',
        allowTimes: function getArr() {
            var allowTimes = [
                '00:05', '00:30', '01:00', '01:30', '02:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30',
                '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30',
                '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30',
                '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30', '23:59'
            ];
            return allowTimes;
        }(),
        onSelectTime: function (selectedTime) {
            $('.dateLeave').focus();
            timePicker(selectedTime, '.start_time');
        }
    });

    $('.priorityTimeEntry').datetimepicker({
        datepicker: false,
        format: 'H:i',
        defaultTime: '08:00',
        formatTime: 'H:i',
        allowTimes: function getArr() {
            var allowTimes = [
                '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00',
                '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00',
                '18:30', '19:00', '19:30', '20:00', '20:30', '21:00'
            ];
            return allowTimes;
        }(),
        onSelectTime: function (selectedTime) {
            $('.dateLeave').focus();
            timePicker(selectedTime, '.start_time');
        }
    });

    $('.timeLeave').datetimepicker({
        datepicker: false,
        format: 'H:i',
        defaultTime: '20:00',
        formatTime: 'H:i',
        allowTimes: function getArr() {
            var allowTimes = [
                '00:05', '00:30', '01:00', '01:30', '02:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30',
                '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30',
                '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30',
                '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30', '23:59'
            ];
            return allowTimes;
        }(),
        onSelectTime: function (selectedTime) {
            timePicker(selectedTime, '.end_time');
        }
    });
});

$(window).on('resize orientationchange', function () {
    setupDatePickers();
});

function setupDatePickers() {
    //Destroy existing date pickers
    var $datePickers = $('.datepickerEntry, .datepickerEntry-mobile, .datepickerEntry-tablet, .datepickerLeave, .datepickerLeave-mobile, .datepickerLeave-tablet');
    var $openedDatePicker = null;
    $datePickers.each(function () {
        var $datePicker = $(this);
        var datePickerClass = '';
        if ($datePicker.hasClass('datepickerEntry-mobile') || $datePicker.hasClass('datepickerEntry-tablet')) {
            $datePicker.removeClass('datepickerEntry-tablet');
            $datePicker.removeClass('datepickerEntry-mobile');
            if (!$datePicker.hasClass('datepickerEntry'))
                $datePicker.addClass('datepickerEntry');
        } else if ($datePicker.hasClass('datepickerLeave-mobile') || $datePicker.hasClass('datepickerLeave-tablet')) {
            $datePicker.removeClass('datepickerLeave-tablet');
            $datePicker.removeClass('datepickerLeave-mobile');
            if (!$datePicker.hasClass('datepickerLeave'))
                $datePicker.addClass('datepickerLeave');
        }
        $datePicker.datepicker('hide');
        $datePicker.datepicker('destroy');
        $datePicker.trigger('blur');
    });

    //Reduces the number of months in the date picker depending on screen size
    if ($(window).width() < 550) {
        $('.datepickerEntry').switchClass('datepickerEntry', 'datepickerEntry-mobile');
        $('.datepickerLeave').switchClass('datepickerLeave', 'datepickerLeave-mobile');
        activeDatePickerLeaveClass = '.datepickerLeave-mobile';
    }
    if ($(window).width() < 1000) {
        $('.datepickerEntry').switchClass('datepickerEntry', 'datepickerEntry-tablet');
        $('.datepickerLeave').switchClass('datepickerLeave', 'datepickerLeave-tablet');
        activeDatePickerLeaveClass = '.datepickerLeave-tablet';
    }

    //Calls for the date and time pickers depending on Leave/Entry and device size
    $('.datepickerEntry').datepicker({
        numberOfMonths: 3,
        defaultDate: '+1',
        showButtonPanel: true,
        dateFormat: 'dd/mm/yy',
        minDate: 0,
        onSelect: function (selectedDate) {
            datePickerEntry(selectedDate);
        },
        beforeShow: function (selectedDate) {
            setHeaderFixedState();
        },
        prevText: '',
        nextText: ''
    });

    $('.datepickerEntry-tablet').datepicker({
        numberOfMonths: 2,
        showButtonPanel: true,
        dateFormat: 'dd/mm/yy',
        minDate: 0,
        onSelect: function (selectedDate) {
            datePickerEntry(selectedDate);
        },
        beforeShow: function (selectedDate) {
            setHeaderFixedState();
        },
        prevText: '',
        nextText: ''
    });

    $('.datepickerEntry-mobile').datepicker({
        numberOfMonths: 1,
        showButtonPanel: true,
        dateFormat: 'dd/mm/yy',
        minDate: 0,
        onSelect: function (selectedDate) {
            datePickerEntry(selectedDate);
        },
        beforeShow: function (selectedDate) {
            setHeaderFixedState();
        },
        prevText: '',
        nextText: ''
    });

    $('.datepickerLeave').datepicker({
        numberOfMonths: 3,
        defaultDate: '+8',
        showButtonPanel: true,
        dateFormat: 'dd/mm/yy',
        minDate: 0,
        onSelect: function (selectedDate) {
            $('.timeLeave').focus();
            datePickerLeave(selectedDate);
        },
        beforeShow: function (selectedDate) {
            setHeaderFixedState();
        },
        prevText: '',
        nextText: ''
    });

    $('.datepickerLeave-tablet').datepicker({
        numberOfMonths: 2,
        defaultDate: '+8',
        showButtonPanel: true,
        dateFormat: 'dd/mm/yy',
        minDate: 0,
        onSelect: function (selectedDate) {
            $('.timeLeave').focus();
            datePickerLeave(selectedDate);
        },
        beforeShow: function (selectedDate) {
            setHeaderFixedState();
        },
        prevText: '',
        nextText: ''
    });

    $('.datepickerLeave-mobile').datepicker({
        numberOfMonths: 1,
        defaultDate: '+8',
        showButtonPanel: true,
        dateFormat: 'dd/mm/yy',
        minDate: 0,
        onSelect: function (selectedDate) {
            $('.timeLeave').focus();
            datePickerLeave(selectedDate);
        },
        beforeShow: function (selectedDate) {
            setHeaderFixedState();
        },
        prevText: '',
        nextText: ''
    });
}

function setHeaderFixedState() {
    var $datepickerDiv = $('#ui-datepicker-div');
    $datepickerDiv.css('margin-top', '');
    $datepickerDiv.attr('data-header-fixed', $('[role=banner]').hasClass('is-fixed'));
}

$(window).on('load', function () {
    $('.datepickerEntry-custom').datepicker({
        numberOfMonths: 1,
        defaultDate: '+1',
        showButtonPanel: true,
        dateFormat: 'dd/mm/yy'
    });

    $('.datepickerDob').datepicker({
        numberOfMonths: 1,
        defaultDate: '+1',
        showButtonPanel: true,
        dateFormat: 'dd/mm/yy',
        prevText: '',
        nextText: ''
    });

    $('.datepickerFlightDate').datepicker({
        numberOfMonths: 1,
        defaultDate: '+1',
        showButtonPanel: true,
        dateFormat: 'dd/mm/yy',
        prevText: '',
        nextText: '',
        minDate: 0
    });
});

function pageLoad() {


    $('.datepickerFlightTime').datetimepicker({
        datepicker: false,
        format: 'H:i',
        defaultTime: '00:00',
        formatTime: 'H:i'
    });
}